import { WGCWX_SHOP_IMAGE_PRELOAD_SUCCESS } from 'state/actions/wgcwx_shop'

const initialState = {
    imagesLoaded: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case WGCWX_SHOP_IMAGE_PRELOAD_SUCCESS:
        return {
            ...state,
            imagesLoaded: true,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/preload_images.js